<atn-ds-page-header name="Team Check-Ins">
  <ng-container actions>
    <atn-ds-button
      #addButton="cdkOverlayOrigin"
      cdkOverlayOrigin
      [isIcon]="true"
      type="white"
      (click)="
        checkInFeature.actions.startCheckIn
          .from('CheckInsPage.AddButton.Clicked')
          .dispatch({ origin: addButton })
      "
    >
      <i class="atn-icon atn-plus atn-blue"></i>
    </atn-ds-button>
  </ng-container>
</atn-ds-page-header>

<atn-ds-search
  class="atn-summit-check-ins-header__search"
  [value]="checkInFeature.selectors.feedSearchQuery.asSignal()"
  (valueChange)="
    checkInFeature.actions.setFeedSearchQuery
      .from('CheckInsPage.SearchInput.Changed')
      .dispatch($event)
  "
/>
